module.exports = __webpack_public_path__ + "img/zhou.ceddf24c.png";